import type { Variable_Speed_Drives } from "gql/api";

export function computeVsdLabel(
  vsd?: Partial<Variable_Speed_Drives> | null
): string {
  if (vsd) {
    return `${vsd.manufacturer} ${vsd.part_number}, ${vsd.kva}, ${vsd.vsd_type}, ${vsd.enclosure}`;
  }
  return "";
}
